import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '⚡',
  title: 'Libéré du Stress de la Planification',
  description: 'Ouvrez le système. Choisissez le volume. Lancez la séance. La planification est déjà faite.'
}, {
  emoji: '👑',
  title: 'Autorité et Confiance',
  description: "Avec une structure éprouvée derrière vous, vous arrivez à l'entraînement en sachant exactement quoi faire et comment le faire."
}, {
  emoji: '📈',
  title: 'Un Vrai Développement des Joueurs',
  description: 'Des progressions structurées aident vos joueurs à progresser plus vite et de façon plus régulière tout au long de la saison.'
}, {
  emoji: '😌',
  title: 'Fini la Panique Avant Chaque Séance',
  description: 'Arrêtez de vous demander quoi faire demain. Football Prêt vous donne une feuille de route complète pour toute l\'année.'
}];
export function Benefits() {
  return <section className="py-20 bg-navy-950 relative" data-id="element-3" data-mp="1ayex5vn5rja8">
      <div className="container mx-auto px-4" data-id="element-4" data-mp="2q4xhngrgwyt">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-5" data-mp="2tkeivtzwg2v">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-6" data-mp="6tkq88ppmd68">
QU'EST-CE QUI VA CHANGER ?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 font-medium" data-id="element-7" data-mp="qfz961pcgfhh">
            Qu'est-ce qui va changer dans votre vie d'entraîneur ?
            <br data-id="element-8" data-mp="1j3ijesu495pp" />
            De vrais bénéfices dès la première semaine.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-9" data-mp="1e5796gzwst6y">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex gap-6 items-start" data-id="element-10" data-mp="1939ix2t3cy4i" data-mpi={index}>
              <div className="flex-shrink-0 w-16 h-16 bg-navy-900 border border-navy-700 rounded-2xl flex items-center justify-center text-3xl shadow-lg" data-id="element-11" data-mp="lg9q4bnvisd5">
                {benefit.emoji}
              </div>
              <div data-id="element-12" data-mp="cfv234jiyz5y">
                <h3 className="font-oswald text-2xl text-white uppercase tracking-wide mb-2" data-id="element-13" data-mp="cfbw8m75g18a">
                  {benefit.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-14" data-mp="2t1028wtrll74">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}